module.exports = __webpack_public_path__ + "img/learn-right-hand.f56a4367.png";